// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"4a02b031","977":"5f1b4e19"}[chunkId] + ".chunk.js";
};